import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Action } from '@wix/wix-help-widget-common/types';
import { v4 as uuid } from 'uuid';

import type { WidgetSessionState } from '../../../types/appState';
import { getWidgetRuntimeState } from '../thunks/widgetRuntime.thunk';

const initialState: WidgetSessionState = {
  // TODO: should we move this to common channel(to have it in each event)
  sessionTabId: uuid(),
  isSessionExpired: false,
};

type UrlChangedAction = {
  readonly action: Action;
  readonly url?: string;
};

export const widgetSessionSlice = createSlice({
  name: 'widgetSession',
  initialState,
  reducers: {
    sessionExpired: (state) => {
      state.sessionId = undefined;
      state.navigationHistory = undefined;
      state.isSessionExpired = true;
    },
    urlChanged: (state, action: PayloadAction<UrlChangedAction>) => {
      state.action = action.payload.action;
      state.url = action.payload.url;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWidgetRuntimeState.fulfilled, (state, action) => {
      if (action.payload.widgetSession) {
        return { ...state, ...action.payload.widgetSession };
      }
    });
  },
});

export const widgetSessionActions = widgetSessionSlice.actions;
